<template>
    <div class="imgs" ref="imgs">
        <img style="width: 100%;" src="../../assets/暂无数据 (2) 1.png" alt="">
        <div style="font-size: 14px;color: #999;">暂无数据</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    props:['width'],
    methods: {
        
    },
    mounted() {
        this.$refs.imgs.style.width = window.innerWidth + 'px'
        this.$refs.imgs.style.height = window.innerHeight-this.width + 'px'
    }
}
</script>
<style>
.imgs {
    /* width: 100%; */
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>